import { Component, inject } from '@angular/core';
import { AccountRequestListConfigService } from '../../../services/account-request-list-config/account-request-list-config.service';
import { CustomerRequestListConfigService } from '../../../services/customer-request-list-config/customer-request-list-config.service';
import { BaseViewConfigService } from '../../../services/base-view-config/base-view-config.service';

@Component({
    selector: 'lib-account-requests-manage',
    templateUrl: './account-requests-manage.component.html',
    styleUrls: ['./account-requests-manage.component.css'],
    standalone: false
})
export class AccountRequestsManageComponent {
  protected showCustomerRequests = inject(BaseViewConfigService).showRequestCustomerAccountLogin;
  public accountRequestListConfigService = inject(AccountRequestListConfigService);
  public customerRequestListConfigService = inject(CustomerRequestListConfigService);
}
